export const bulkUploadfileFormat = {
  basic: ["username", "fullname", "passwordcomplexityid", "password", "scope", "role", "dataid", "availability", "inventory", "action"],
  email: ["username", "fullname", "passwordcomplexityid", "scope", "role", "dataid", "availability", "inventory", "action"],
  SSO: ["username", "fullname", "scope", "role", "dataid", "availability", "inventory", "action"],
};

export const userTypes = {
  basic: "basic",
  email: "email",
  SSO: "sso",
};

export const fileJsonKeyMapping: { [key: string]: string } = {
  username: "username",
  fullname: "fullName",
  password: "password",
  scope: "scopes",
  application: "scopes",
  role: "roles",
  dataid: "dataIds",
  store: "dataIds",
  action: "action",
  passwordcomplexityid: "passwordComplexityId",
  availability: "availability",
  inventory: "inventory",
};

export const jsonFileKeyMapping: { [key: string]: string } = {
  username: "Username",
  fullname: "Fullname",
  passwordcomplexityid: "PasswordComplexityId",
  password: "Password",
  scopes: "Scope",
  roles: "Role",
  dataids: "DataId",
  availability: "Availability",
  inventory: "Inventory",
  action: "Action",
  error: "Error",
};
